module.exports = __webpack_public_path__ + "static/media/table_top_arrow.fddb9311.svg";